import { Container, Table } from 'react-bootstrap';
import PageSectionTitle from '../Layout/PageSectionTitle';
import SubmissionFormatTable from './SubmissionFormatTable';
import "./SubmissionsTextContent.css";

const SubmissionsTextContent = (props) => {
  
  return(
    <div id="submissions-text-content">
      <Container fluid className="con-no-pad">
        <section id='section1'>
          <p className="notification-text">Note: we are no longer accepting new submissions.</p>
          <span>
            For each dataset, participants should submit a point estimate and the bounds of a corresponding 90 percent uncertainty 
            interval for the overall SATT, the year-specific SATT for Years 3 and 4, and for each of the 12 conditional SATTs 
            defined by the 2+3+2+3+2 levels of the categorical variables <span className="var-text">X1,X2,…,X5</span>. the 
            submission format appears below. Participants should submit a single .csv file for each track, with the seven columns 
            in the following table, and with one row per dataset per estimand. The order of rows does not matter. The file should 
            contain 51,000 rows (excluding the header row), reflecting 15 estimands per dataset &times; 3,400 datasets.
          </span>
          <SubmissionFormatTable />
          <span>
            Teams submitting practice-level impacts should submit an additional file for each track with one row per treated practice, 
            per dataset of the following form. The file should contain 680,170 rows (excluding the header row), reflecting approximately 
            200 treatment practices per dataset &times; 3,400 datasets. Note that the <span className="var-text">id.practice</span> variable 
            does not run sequentially for treated practices (e.g. in dataset 0001 the first three treated practices 
            have <span className="var-text">id.practice</span> equal to 1, 2, and 9), and this should be reflected in your submission; do 
            not renumber the practices.
          </span>
          <Table responsive size='md' className="submission-format-table">
            <thead>
              <tr>
                <th>dataset.num</th>
                <th>id.practice</th>
                <th>satt</th>
                <th>lower90</th>
                <th>upper90</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>0001</td>
                <td>1</td>
                <td>.</td>
                <td>.</td>
                <td>.</td>
              </tr>
              <tr>
                <td>0001</td>
                <td>2</td>
                <td>.</td>
                <td>.</td>
                <td>.</td>
              </tr>
              <tr>
                <td>0001</td>
                <td>9</td>
                <td>.</td>
                <td>.</td>
                <td>.</td>
              </tr>
              <tr>
                <td>...</td>
                <td>...</td>
                <td>...</td>
                <td>...</td>
                <td>...</td>
              </tr>
              <tr>
                <td>0001</td>
                <td>499</td>
                <td>.</td>
                <td>.</td>
                <td>.</td>
              </tr>
              <tr>
                <td>0002</td>
                <td>3</td>
                <td>.</td>
                <td>.</td>
                <td>.</td>
              </tr>
              <tr>
                <td>...</td>
                <td>...</td>
                <td>...</td>
                <td>...</td>
                <td>...</td>
              </tr>
              <tr>
                <td>3400</td>
                <td>500</td>
                <td>.</td>
                <td>.</td>
                <td>.</td>
              </tr>
            </tbody>
          </Table>
        </section>

        <section id="section2">
          <PageSectionTitle id="variables">
            Submission
          </PageSectionTitle>
          <div className="submit-box">
            <span>
              We appreciate your interest in the 2022 ACIC competition. However, the competition deadline of May 1st, 2022 has passed and <span 
              className="notification-text">we are no longer accepting new submissions</span>. We hope to see you at ACIC 2023!
            </span>
          </div>
        </section>
      </Container>
    </div>
  )
}

export default SubmissionsTextContent;
